<style lang="scss" scoped>
@import "core";

.my {

  &__attributes {

  }

  &__questionnaire {
    margin-top: 20px;
  }

  &__table {
    th {
      width: 220px;
      max-width: 40%;
      text-align: left;

      @include mq(sp) {
        width: 40%;
      }
    }

    td {
      // width: 100%;
    }

    th,
    td {
      @include mq(pc) {
        padding: 15px;
      }
    }
  }

  &__choice {
    display: inline-block;
    line-height: 2;
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>



<template>
  <div class="my" v-if="isUse">
    <section class="my__attributes">
      <h2 class="mdTtl02">属性入力</h2>
      <table class="my__table dn-table">
        <tbody>
          <tr>
            <th>文系/理系</th>
            <td>
              <label class="my__choice"
                v-for="liberal in LIBERALS"
                :key="liberal.id"
              >
                <input
                  type="radio"
                  :name="liberalInputName"
                  :value="liberal.id"
                  v-model="selectedLiberal"
                >
                {{liberal.name}}
              </label>
            </td>
          </tr>
          <tr>
            <th>所属高校エリア</th>
            <td>
              <select
                :name="prefInputName"
                v-model="selectedPref"
              >
                <option :value="null">都道府県を選択</option>
                <option
                  v-for="pref in PREFS"
                  :key="pref.id"
                  :value="pref.id"
                >{{pref.name}}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="my__questionnaire">
      <h3 class="mdTtl03">アンケート</h3>
      <table class="my__table dn-table">
        <tbody>
          <tr>
            <th>自己採点計算ツールは<wbr>使いやすかったですか？</th>
            <td>
              <label
                class="my__choice"
                v-for="item in QUESTIONNAIRIES"
                :key="item.id"
              >
                <input
                  type="radio"
                  :name="questionnaireInputName"
                  :value="item.id"
                  v-model="selectedQuestionnaire"
                >
                {{item.name}}
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>



<script>
import prefs from 'constants/prefs';



const LIBERALS = [
  {id: '1', name: '文系'},
  {id: '2', name: '理系'},
];

const QUESTIONNAIRIES = [
  {id: '1', name: '使いやすかった'},
  {id: '2', name: '使いにくかった'},
];



export default {
  computed: {
    PREFS: () => prefs,
    LIBERALS: () => LIBERALS,
    QUESTIONNAIRIES: () => QUESTIONNAIRIES,

    isUse() { return !this.$store.getters['path/locationIsMatchBackup'] && !this.$store.getters['config/isManabi'] },

    liberalInputName() { return `${this._uid}_selfcheck_liberal` },
    prefInputName() { return `${this._uid}_selfcheck_pref` },
    questionnaireInputName() { return `${this._uid}_selfcheck_pref` },

    selectedLiberal: {
      get() { return this.$ls.get('self_check_attributes.liberal', null) },
      set(val) {
        return this.$ls.set('self_check_attributes.liberal', val);
      },
    },
    selectedPref: {
      get() { return this.$ls.get('self_check_attributes.pref', null) },
      set(val) {
        return this.$ls.set('self_check_attributes.pref', val);
      },
    },
    selectedQuestionnaire: {
      get() { return this.$ls.get('self_check_attributes.questionnaire', null) },
      set(val) {
        return this.$ls.set('self_check_attributes.questionnaire', val);
      },
    },
    targetValues() {
      return this.isUse ? {
        liberal: this.selectedLiberal,
        pref: this.selectedPref,
        questionnaire: this.selectedQuestionnaire,
      } : {
        liberal: '9',
        pref: '99',
        questionnaire: '9',
      };
    },
    errors() {
      const errors = [];

      if (this.isUse) {
        if (this.selectedLiberal === null) errors.push('「文系/理系」が選択されていません');
        if (this.selectedPref === null) errors.push('「所属高校エリア」が選択されていません');
        if (this.selectedQuestionnaire === null) errors.push('「アンケート」が選択されていません');
      }

      return errors;
    },
    valid() { return !this.errors.length },
  },
}
</script>



// WEBPACK FOOTER //
// Option.vue?083fe4b3